// Título do prontuário com os atendimentos (realizados/total), no mesmo cálculo do Progresso da tela do prontuário
export const prontuarioLabel = (prontuario) => {
  if (!prontuario?.titulo) return ''
  if (!prontuario.progresso) return prontuario.titulo

  return `${prontuario.titulo} - Atendimentos: ${prontuario.progresso}`
}
